export default __webpack_public_path__ + "img/gYSxopTy.ca7c54d0.svg";